<button kendoButton size="large" style="width: 100%;" (click)="this.open()">{{'Servos' | translate: 'Servos'}}</button>
<kendo-dialog *ngIf="isEditing" title="{{'Servos' | translate: 'Servos'}}" width="850px" [height]="'auto'" [maxHeight]="'85%'" (close)="this.close()">
    @if (this.jsBridgeService.isDev()) {
        <translation-editor />
    }
    <div class="wgrid element-container">
        <div>{{'Omschrijving' | translate: 'Omschrijving'}}</div>
        <div>{{'Soort' | translate: 'Soort'}}</div>
        <div>{{'Uitgang' | translate: 'Uitgang'}}</div>
        <div class="param-header">{{'Params' | translate: 'Params'}}</div>
        @for (servo of propsService.servos(); track servo.index) {
            <servo-editor [onlyContents]="true" [initialValue]="servo" [class.led-even]="$even" [class.led-odd]="$odd" class="mouse-over" style="display: contents;" />
        }
    </div>
    <div class="splitter"></div>
    @for (servo of availableServos(); track servo.index) {
        <servo-editor [initialValue]="servo" [class.led-even]="$even" [class.led-odd]="$odd" class="mouse-over" [onlyDesc]="true" />
    }    
</kendo-dialog>